
<div class="toggle-arrow" :class="parentClasses" v-tooltip="statusName">
  <input type="checkbox" :class="classes" :disabled="disabled" v-bind:checked="status" :id="setID" :name="id" :value="setVal" @change="switchStatus"/>
</div>
